import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { closeDrawer } from "./drawerSlice";
import { useAppDispatch, useAppSelector } from "../../hooks";
import { useEffect, useState } from "react";
import logo from '../../assets/HNELogo.png';
import { DrawerItems } from "./DrawerConfig";
import { hasPermission } from "../../Features/Shared/Login/hasPermission";
import { logoutUser } from "../../Features/Shared/Login/LoginSlice";
import { ExpandLess, ExpandMore, Logout, Psychology } from "@mui/icons-material";
import './Drawer.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Drawer = () => {
    const dispatch = useAppDispatch();
    const location = useLocation();
    const isOpen = useAppSelector((state) => state.drawer.isDrawerOpen)
    const permissions = useAppSelector((state) => state.auth.permissions)
    const [visible, setVisible] = useState<boolean>(false);
    const [agentsOpen, setAgentsOpen] = useState<boolean>(false);

    useEffect(() => {
        dispatch(closeDrawer());
    }, [location.pathname]);
    
    useEffect(() => {
        if (isOpen) {
            setVisible(true);
        } else {
            const timeout = setTimeout(() => setVisible(false), 300);

            return () => clearTimeout(timeout);
        }
    }, [isOpen]);

    const authorizedItems = DrawerItems.filter(item => {
        const requirements = item.requirements;

        if (!requirements) return true;

        return hasPermission(
            permissions,
            requirements.permission,
            requirements.level,
        );
    });

    const handleLogout = () => {
        dispatch(logoutUser());
    };

    // const topLevelItems = authorizedItems.filter(
    //     item => !item.hidden && !item.group
    // )

    return (
        <>
            {visible && (
                <div 
                    className={`offcanvas-backdrop fade ${isOpen ? "show" : "hidden"}`}
                    onClick={() => dispatch(closeDrawer())}
                />
            )}

            <div 
                className={`offcanvas offcanvas-start ${isOpen ? "show" : "hidden"}`}
                style={{ visibility: isOpen ? 'visible' : 'hidden', }}
                tabIndex={-1}
                aria-hidden={!isOpen}
                id="menu"
            >
                <div 
                    className="offcanvas-header"
                >
                    <button 
                        onClick={() => dispatch(closeDrawer())} 
                        type="button" 
                        className="btn-close" 
                        data-bs-dismiss="offcanvas" 
                        aria-label="Close">
                    </button>
                </div>
                <div>
                    <img 
                        src={logo}
                        style={{ height: '175px', margin: '-10px'}}
                    />
                    <div className="fw-bold">COMMAND CENTER</div>
                </div>
                <div className="offcanvas-body drawer-body">
                    {authorizedItems.map((item) => {
                        console.log(item.icon, item.iconType)
                        return (
                            <>
                                {item.type !== 'back' && 
                                    <div
                                        className={location.pathname === item.path ? 'bg-primary text-light' : 'text-secondary'} 
                                        style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', borderRadius: 10, height: '50px' }}>
                                        <div className="col-2">
                                            {item.iconType === 'mui' ? (
                                                <item.icon />
                                            ) : item.iconType === 'fa-comp' ? (
                                                <FontAwesomeIcon icon={item.icon} size="lg" />
                                            ) : (
                                                <i className={`${item.icon}`}></i>
                                            )}
                                        </div>
                                        <NavLink 
                                            className="nav-link col-10 d-flex"
                                            to={item.path}
                                        >
                                            {item.label}
                                        </NavLink>
                                    </div>
                                }
                            </>
                        )
                    })}
                    <div 
                        className={
                            location.pathname === '/AskJiro' || location.pathname === '/PIM' 
                            ? 'bg-primary text-light' 
                            : 'text-secondary'
                        }
                        style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', borderRadius: 10, height: '50px' }}
                        onClick={() => setAgentsOpen(!agentsOpen)}
                    >
                        <div className="col-2">
                            <Psychology />
                        </div>
                        <div className="col-8 d-flex">
                            AI Agents
                        </div>
                        <div className="col-8 d-flex">
                            {agentsOpen ? <ExpandLess /> : <ExpandMore />}
                        </div>
                    </div>
                    <div className={`agents-container ${agentsOpen ? 'open' : ''}`}>
                        <NavLink
                            to={'/AskJiro'}
                            className={location.pathname === '/AskJiro' ? 'bg-primary text-light col-10 d-flex nav-link' : 'text-secondary col-10 d-flex nav-link'}
                            style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', borderRadius: 10, height: '50px', marginInlineStart: 50, paddingLeft: 10 }}
                        >
                            AskJiro
                        </NavLink>
                        <NavLink
                            to={'/PIM'}
                            className={location.pathname === '/PIM' ? 'bg-primary text-light col-10 d-flex nav-link' : 'text-secondary col-10 d-flex nav-link'}
                            style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', borderRadius: 10, height: '50px', marginInlineStart: 50, paddingLeft: 10 }}
                        >
                            PIM Agent
                        </NavLink>
                    </div>
                    <div
                        className="mt-2"
                        style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', borderRadius: 10, height: '50px' }}
                    >
                        <div className="col-2">
                            <Logout />
                        </div>
                        <div 
                            className="col-10 d-flex"
                            style={{ flexDirection: 'row', alignItems: 'center'}}
                            onClick={handleLogout}
                        >
                            <span>Logout</span>
                        </div>
                    </div>
                </div>
                <div className='d-flex justify-content-end pe-1'>
                    <span>Version: {process.env.REACT_APP_VERSION}</span>
                </div>
            </div>
        </>
    )
};

export default Drawer;